import { render } from "./UiTextArea.vue?vue&type=template&id=dbfb357c&scoped=true"
import script from "./UiTextArea.vue?vue&type=script&lang=js"
export * from "./UiTextArea.vue?vue&type=script&lang=js"

import "./UiTextArea.vue?vue&type=style&index=0&id=dbfb357c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfb357c"]])

export default __exports__